import { render, staticRenderFns } from "./mediaManager.vue?vue&type=template&id=d84e0880&"
import script from "./mediaManager.vue?vue&type=script&lang=js&"
export * from "./mediaManager.vue?vue&type=script&lang=js&"
import style0 from "./mediaManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports